module.exports = __webpack_public_path__ + "static/media/S (21).74824237.jpg";